module.exports = __webpack_public_path__ + "static/media/besties-coke-fr.3b124c9b.svg";